export enum EquipementAction {
    GET_NON_PREVENTIVE_STATS = 'GET_NON_PREVENTIVE_STATS',
    GET_PREVENTIVE_STATS_CIRCLE = 'GET_PREVENTIVE_STATS_CIRCLE',
    GET_PREVENTIVE_STATS_CHART = 'GET_PREVENTIVE_STATS_CHART',

    GET_DEVIS_STATS = 'GET_DEVIS_STATS',
    GET_DEMANDES_INTERVENTION_STATS = 'GET_DEMANDES_INTERVENTION_STATS',
    GET_DETAILS_EQUIPEMENT = 'GET_DETAILS_EQUIPEMENT',
    GET_CARACTERISTIQUES_EQUIPEMENT = 'GET_CARACTERISTIQUES_EQUIPEMENT',
    GET_OPERATION_MAINTENANCE = 'GET_OPERATION_MAINTENANCE',
    HISTORIQUE_TRAVAUX_NAV_FILTER = 'HISTORIQUE_TRAVAUX_NAV_FILTER',
    INTERVENTIONS_PREVENTIVES_NAV_FILTER = 'INTERVENTIONS_PREVENTIVES_NAV_FILTER',
    DEVIS_NAV_FILTER = 'DEVIS_NAV_FILTER',
    DEMANDES_INTERVENTION_NAV_FILTER = 'DEMANDES_INTERVENTION_NAV_FILTER',
}
